import ENV from './index.env';

export default ENV;

export const ServiceURL = {
  COMMON: replaceWorksDefaultDomainOrNot(ENV.COMMON_URL),
  NOTIFY: replaceWorksDefaultDomainOrNot(ENV.NOTIFY_URL),
  BOARD: replaceWorksDefaultDomainOrNot(ENV.BOARD_URL),
  TALK: replaceWorksDefaultDomainOrNot(ENV.TALK_URL),
  MAIL: replaceWorksDefaultDomainOrNot(ENV.MAIL_URL),
  CALENDAR: replaceWorksDefaultDomainOrNot(ENV.CALENDAR_URL),
  CONTACT: replaceWorksDefaultDomainOrNot(ENV.CONTACT_URL),
  DRIVE: replaceWorksDefaultDomainOrNot(ENV.DRIVE_URL),
  TASK: replaceWorksDefaultDomainOrNot(ENV.TASK_URL),
  FORM: replaceWorksDefaultDomainOrNot(ENV.FORM_URL),
  AUTH: replaceWorksDefaultDomainOrNot(ENV.AUTH_URL),
  TEMPLATE: replaceWorksDefaultDomainOrNot(ENV.TEMPLATE_URL),
  ADMIN: replaceWorksDefaultDomainOrNot(ENV.ADMIN_URL),
  WORKPLACE_URL : ENV.WORKPLACE_URL,
};

export function replaceWorksDefaultDomainOrNot(
  url,
  defaultDomain = 'navercorp.com',
  otherDomains = ['linecorp.com', 'nsbc.co.kr'],
) {
  if (!['works', 'workscb', 'worksob'].includes(ENV.TARGET)) {
    return url;
  }

  const { hostname } = location;
  for (const otherDomain of otherDomains) {
    if (hostname.includes(otherDomain)) {
      return url.replace(defaultDomain, otherDomain);
    }
  }
  return url;
}
